<template>
  <v-container fluid class="menu-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-menu`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Menu
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-groups`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Groups
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-subgroups`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Subgroups
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Items
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-channels`"
          >
            <v-icon class="mr-3">mdi-router</v-icon>
            Channels
          </v-tab>
          <v-tab-item
            :value="'tab-menu'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Menu</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMenu($event, 'menucode')"
                        v-bind:value="initvalue.menucode"
                        placeholder="Menu Code"
                        persistent-hint
                        single-line hint="Enter the menu code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMenu($event, 'menuname')"
                        v-bind:value="initvalue.menuname"
                        placeholder="Menu Name"
                        persistent-hint
                        single-line hint="Enter the menu name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=menutype
                        :value="initvalue.menutype"
                        outlined
                        dense
                        v-on:change="onChangeMenu($event, 'menutype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the menu type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeMenu($event, 'menustatus')"
                          v-bind:label="initvalue.menustatus"
                          v-model="initvalue.menustatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/menu/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editMenuRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-groups'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Menu Groups</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddGroup = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="grouprank"
                        :headers="groupHeaders"
                        :items="menugroups"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteGroup" width="500">
                            <v-card>
                              <v-card-title> Delete this Group? </v-card-title>
                              <v-card-text>
                                {{ delete_group.groupname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteGroup = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteMenuGroup(delete_group)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.groupname="{ item }">
                          <p class="two-line">{{ item.groupname }}</p>
                          <p class="two-line">{{ item.groupcode }}</p>
                        </template>
                        <template v-slot:item.grouplink="{ item }">
                          <p class="two-line">{{ item.grouplink }}</p>
                          <p class="two-line">{{ item.groupaction }}</p>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editMenuGroupDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteMenuGroupDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/menu/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-subgroups'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Menu Subgroups</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddSubgroup = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="subgrouprank"
                        :headers="subgroupHeaders"
                        :items="menusubgroups"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteSubgroup" width="500">
                            <v-card>
                              <v-card-title> Delete this Subgroup? </v-card-title>
                              <v-card-text>
                                {{ delete_group.subgroupname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteSubgroup = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteMenuSubgroup(delete_subgroup)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <!-- <template v-slot:item.groupid="{ item }">
                          <p class="two-line" v-if="item.groupid!=undefined">{{ menugroups.length>0 ? menugroups.find(group=>group._id == item.groupid)['groupname'] : ''  }}</p>
                        </template>  -->
                        <template v-slot:item.subgroupname="{ item }">
                          <p class="two-line">{{ item.subgroupname }}</p>
                          <p class="two-line">{{ item.subgroupcode }}</p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editMenuSubgroupDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteMenuSubgroupDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/menu/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Menu Items</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="itemrank"
                        :headers="itemHeaders"
                        :items="menuitems"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_item.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteMenuItem(delete_item)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.groupid="{ item }">
                          <p class="two-line" v-if="item.groupid!=undefined">{{ menugroups.length>0 && menugroups.find(group=>group._id == item.groupid) ? menugroups.find(group=>group._id == item.groupid)['groupname'] || '' : ''  }}</p>
                        </template>
                        <template v-slot:item.subgroupid="{ item }">
                          <p class="two-line" v-if="item.subgroupid!=undefined">{{ menusubgroups.length>0 ? menusubgroups.find(subgroup=>subgroup._id == item.subgroupid)['subgroupname'] : ''  }}</p>
                        </template>
                        <template v-slot:item.itemname="{ item }">
                          <p class="two-line"><strong>{{ item.itemname }}</strong></p>
                          <p class="two-line">{{ item.itemcode  }}</p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editMenuItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteMenuItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/menu/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddGroup"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Group</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>

            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_group.grouprank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['Mobile', 'Web']"
                  v-model="add_group.groupclass"
                  v-bind:error="errorindex == 1"
                  placeholder="Class"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['Chart', 'Menu', 'Widget']"
                  v-model="add_group.grouptype"
                  v-bind:error="errorindex == 1"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_group.groupname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_group.groupcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_group.groupicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_group.grouplink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_group.groupaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddGroup=false; add_group={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addMenuGroupRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddSubgroup"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Subgroup</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>

            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_subgroup.subgrouprank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-select
                  class="mb-4"
                  :items="menugroups.map(x => {
                    return {text: x.groupcode, value: x._id};
                  })"
                  v-model="add_subgroup.groupid"
                  v-bind:error="errorindex == 3"
                  placeholder="Group"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_subgroup.subgroupname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_subgroup.subgroupcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_subgroup.subgroupicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddSubgroup=false; add_subgroup={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addMenuSubgroupRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_item.itemrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="menugroups.map(x => {
                    return {text: x.groupcode, value: x._id};
                  })"
                  v-model="add_item.groupid"
                  v-bind:error="errorindex == 3"
                  placeholder="Group"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="menusubgroups.map(x => {
                    return {text: x.subgroupcode, value: x._id};
                  })"
                  v-model="add_item.subgroupid"
                  v-bind:error="errorindex == 3"
                  placeholder="Subgroup"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_item.itemlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_item.itemaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddItem=false; add_item={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addMenuItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditGroup"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Group</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeGroup($event, 'grouprank')"
                  :value="edit_group.grouprank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['Mobile', 'Web']"
                  v-on:change="onChangeGroup($event, 'groupclass')"
                  :value="edit_group.groupclass"
                  v-bind:error="errorindex == 11"
                  placeholder="Class"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['Chart', 'Menu', 'Widget']"
                  v-on:change="onChangeGroup($event, 'grouptype')"
                  :value="edit_group.grouptype"
                  v-bind:error="errorindex == 12"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeGroup($event, 'groupname')"
                  :value="edit_group.groupname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeGroup($event, 'groupcode')"
                  :value="edit_group.groupcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeGroup($event, 'groupicon')"
                  :value="edit_group.groupicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeGroup($event, 'grouplink')"
                  :value="edit_group.grouplink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeGroup($event, 'groupaction')"
                  :value="edit_group.groupaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditGroup = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editMenuGroupRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditSubgroup"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Subgroup</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeSubgroup($event, 'subgrouprank')"
                  :value="edit_subgroup.subgrouprank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-select
                  class="mb-4"
                  :items="menugroups.map(x => {
                    return {text: x.groupcode, value: x._id};
                  })"
                  v-on:change="onChangeSubgroup($event, 'groupid')"
                  :value="edit_subgroup.groupid"
                  placeholder="Group"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeSubgroup($event, 'subgroupname')"
                  :value="edit_subgroup.subgroupname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeSubgroup($event, 'subgroupcode')"
                  :value="edit_subgroup.subgroupcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeSubgroup($event, 'subgroupicon')"
                  :value="edit_subgroup.subgroupicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditSubgroup = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editMenuSubgroupRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemrank')"
                  :value="edit_item.itemrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="menugroups.map(x => {return {text: x.groupcode, value: x._id};})"
                  v-on:change="onChangeItem($event, 'groupid')"
                  :value="edit_item.groupid"
                  placeholder="Group"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="menusubgroups.map(x => {
                    return {text: x.subgroupcode, value: x._id};
                  })"
                  v-on:change="onChangeItem($event, 'subgroupid')"
                  :value="edit_item.subgroupid"
                  placeholder="Subgroup"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemname')"
                  :value="edit_item.itemname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemcode')"
                  :value="edit_item.itemcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemicon')"
                  :value="edit_item.itemicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemlink')"
                  :value="edit_item.itemlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemaction')"
                  :value="edit_item.itemaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditItem=false; edit_item={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editMenuItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      groupHeaders: [
        { text: "#", value: "grouprank", width: "10px" },
        { text: "Class", value: "groupclass" },
        { text: "Type", value: "grouptype" },
        { text: "Name & Code", value: "groupname" },
        { text: "Link & Action", value: "grouplink" },
        { text: "Icon", value: "groupicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      subgroupHeaders: [
        { text: "#", value: "subgrouprank", width: "10px" },
        { text: "Group", value: "groupid" },
        { text: "Name & Code", value: "subgroupname" },
        { text: "Icon", value: "subgroupicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      itemHeaders: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Group", value: "groupid" },
        { text: "Subgroup", value: "subgroupid" },
        { text: "Name & Code", value: "itemname" },
        { text: "Icon", value: "itemicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      menu: {},
      menugroups: [],
      menusubgroups: [],
      menuchannels: [],
      menuitems: [],
      menutype: ['Menu', 'Other Menu'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      add_group: {},
      add_subgroup: {},
      add_item: {},
      add_channel: {},
      edit_group: {},
      edit_subgroup: {},
      edit_item: {},
      edit_channel: {},
      change_menu: {},
      change_group: {},
      change_subgroup: {},
      change_item: {},
      change_channel: {},
      delete_group: {},
      delete_subgroup: {},
      delete_item: {},
      delete_channel: {},
      isDeleteGroup: false,
      isDeleteSubgroup: false,
      isDeleteItem: false,
      isDeleteChannel: false,
      isAddGroup: false,
      isAddSubgroup: false,
      isAddItem: false,
      isAddChannel: false,
      isEditGroup: false,
      isEditSubgroup: false,
      isEditItem: false,
      isEditChannel: false,
    }
  },
  computed: {
    ...mapState('Menu', ['isReceiving'])
  },
  methods: {
    ...mapActions('Menu', 
    [ 'getMenusRequest',
      'deleteMenuGroupRequest', 'deleteMenuSubgroupRequest', 'deleteMenuItemRequest',
      'insertMenuGroupRequest', 'insertMenuSubgroupRequest', 'insertMenuItemRequest',
      'updateMenuRequest','updateMenuGroupRequest','updateMenuSubgroupRequest','updateMenuItemRequest' 
    ]),
    async addMenuGroupRequest() {
      this.isAddGroup = false;
      this.add_group.menuid = this.initvalue._id;
      let result = await this.insertMenuGroupRequest(this.add_group);
      this.menugroups.push(result);
      this.add_group = {};
    },
    async addMenuSubgroupRequest() {
      this.isAddSubgroup = false;
      this.add_subgroup.menuid = this.initvalue._id;
      let result = await this.insertMenuSubgroupRequest(this.add_subgroup);
      this.menusubgroups.push(result);
      this.add_subgroup = {};
    },
    async addMenuItemRequest() {
      this.isAddItem = false;
      this.add_item.menuid = this.initvalue._id;
      let result = await this.insertMenuItemRequest(this.add_item);
      this.menuitems.push(result);
      this.add_item = {};
    },
    async addMenuChannelRequest() {
      this.isAddChannel = false;
      this.add_channel.menuid = this.initvalue._id;
      let result = await this.insertMenuChannelRequest(this.add_channel);
      this.menuchannels.push(result);
      this.add_channel = {};
    },
    deleteMenuGroupDialog(item) {
      this.isDeleteGroup = true;
      this.delete_group = {
        _id: item._id,
        groupname: item.groupname,
      };
    },
    deleteMenuSubgroupDialog(item) {
      this.isDeleteSubgroup = true;
      this.delete_subgroup = {
        _id: item._id,
        subgroupname: item.subgroupname,
      };
    },
    deleteMenuItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = {
        _id: item._id,
        itemname: item.itemname,
      };
    },
    deleteMenuChannelDialog(item) {
      this.isDeleteChannel = true;
      this.delete_channel = {
        _id: item._id,
        channelname: item.channelname,
      };
    },
    async deleteMenuGroup(payload) {
      this.isDeleteGroup = false;
      let response = await this.deleteMenuGroupRequest(payload);
      let index = this.menugroups.findIndex((trans) => trans._id == response._id);
      this.menugroups.splice(index, 1);
    },
    async deleteMenuSubgroup(payload) {
      this.isDeleteSubgroup = false;
      let response = await this.deleteMenuSubgroupRequest(payload);
      let index = this.menusubgroups.findIndex((trans) => trans._id == response._id);
      this.menusubgroups.splice(index, 1);
    },
    async deleteMenuItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteMenuItemRequest(payload);
      let index = this.menuitems.findIndex((trans) => trans._id == response._id);
      this.menuitems.splice(index, 1);
    },
    async deleteMenuChannel(payload) {
      this.isDeleteChannel = false;
      let response = await this.deleteMenuChannelRequest(payload);
      let index = this.menuchannels.findIndex((trans) => trans._id == response._id);
      this.menuchannels.splice(index, 1);
    },
    editMenuGroupDialog(item) {
      this.edit_group = Object.assign({}, item);
      this.change_group = {};
      this.isEditGroup = true;
    },
    editMenuSubgroupDialog(item) {
      this.edit_subgroup = Object.assign({}, item);
      this.change_subgroup = {};
      this.isEditSubgroup = true;
    },
    editMenuItemDialog(item) {
      this.edit_item = Object.assign({}, item);
      this.change_item = {};
      this.isEditItem = true;
    },
    editMenuChannelDialog(item) {
      this.edit_channel = Object.assign({}, item);
      this.change_channel = {};
      this.isEditChannel = true;
    },
    async editMenuRequest() {
      this.change_menu._id = this.initvalue._id;
      await this.updateMenuRequest(this.change_menu);
      router.push('/menu/list');
    },
    async editMenuGroupRequest() {
      this.isEditGroup = false;
      this.change_group.menugroupid = this.edit_group._id;
      let response = await this.updateMenuGroupRequest(this.change_group);
      let index = this.menugroups.findIndex((x) => x._id == response._id);
      this.menugroups.splice(index, 1, response);
      this.edit_group = {};
    },
    async editMenuSubgroupRequest() {
      this.isEditSubgroup = false;
      this.change_subgroup.menusubgroupid = this.edit_subgroup._id;
      let response = await this.updateMenuSubgroupRequest(this.change_subgroup);
      let index = this.menusubgroups.findIndex((x) => x._id == response._id);
      this.menusubgroups.splice(index, 1, response);
      this.edit_subgroup = {};
    },
    async editMenuItemRequest() {
      this.isEditItem = false;
      this.change_item.menuitemid = this.edit_item._id;
      let response = await this.updateMenuItemRequest(this.change_item);
      let index = this.menuitems.findIndex((x) => x._id == response._id);
      this.menuitems.splice(index, 1, response);
      this.edit_item = {};
    }, 
    async editMenuChannelRequest() {
      this.isEditChannel = false;
      this.change_channel.menuitemid = this.edit_channel._id;
      let response = await this.updateMenuChannelRequest(this.change_channel);
      let index = this.menuchannels.findIndex((x) => x._id == response._id);
      this.menuchannels.splice(index, 1, response);
      this.edit_channel = {};
    },    
    onChangeMenu(value, field){
      this.change_menu[field] = value;
    },
    onChangeGroup(value, field){
      this.change_group[field] = value;
    },
    onChangeSubgroup(value, field){
      this.change_subgroup[field] = value;
    },
    onChangeItem(value, field){
      this.change_item[field] = value;
    },  
    onChangeChannel(value, field){
      this.change_channel[field] = value;
    },     
  },

  created () {
    this.initvalue = this.$route.params;
    this.menugroups = this.initvalue.groups;
    this.menusubgroups = this.initvalue.subgroups;
    this.menuitems = this.initvalue.items;
    if(!this.initvalue._id) this.$router.push({ name: 'MenuList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
